import React from 'react'
import { graphql } from 'gatsby'
import styled from '@emotion/styled'

import type { Paragraph, ParagraphComponent } from '../types'

import Container from '../../Container'
import { widths, media } from '../../../styles/variables'

export interface TextParagraph extends Paragraph {
	field_text: {
		processed: string
	}
	columns: number
}

const Text: ParagraphComponent<TextParagraph> = ({ className, paragraph }) => (
	<Container className={className} dangerouslySetInnerHTML={{ __html: paragraph.field_text.processed }} />
)

export default styled(Text)`
	${({ paragraph: { columns } }) =>
		columns && columns > 1
			? {
					[media.up('md')]: { columns: columns }
			  }
			: {
					maxWidth: `${widths.md}px !important`
			  }}
`

export const query = graphql`
	fragment TextParagraph on paragraph__paragraph {
		drupal_internal__id
		field_text {
			processed
		}
		columns: field_number
	}
`
